import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    window.addEventListener('letterStatesChanged', (e) => {
      this.updateKeyColors(e.detail.letterStates, e.detail.useCounts)
    })

    if (!window._keyboardBound) {
      window._keyboardBound = true

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace') {
          e.preventDefault()
          this.backspace()
        } else if (e.key === 'Enter') {
          e.preventDefault()
          this.submit()
        } else if (/^[a-zA-Z]$/.test(e.key)) {
          if (e.target.id === 'mobile-input') return
          this.addLetter(e.key.toUpperCase())
        }
      })

      // Mobile: route characters from the hidden input through addLetter,
      // then clear it so each keystroke is independent.
      const mobileInput = document.getElementById('mobile-input')
      mobileInput.focus()
      if (mobileInput) {
        mobileInput.addEventListener('input', (e) => {
          const value = e.target.value
          for (const char of value) {
            if (/^[a-zA-Z]$/.test(char)) {
              this.addLetter(char.toUpperCase())
            }
          }
          e.target.value = ''
        })

        // Re-focus the hidden input on taps so the native keyboard stays up
        document.querySelector('main').addEventListener('click', () => {
          if (window.innerWidth <= 600) {
            mobileInput.focus()
          }
        })
      }

      const toggleBtn = document.getElementById('show-keyboard')
      if (toggleBtn) {
        toggleBtn.addEventListener('click', (e) => {
          e.preventDefault()
          const main = document.querySelector('main')
          const showing = main.classList.toggle('show-keyboard')
          toggleBtn.textContent = showing ? 'Hide Keyboard' : 'Show Keyboard'
        })
      }
    }
  }

  dispatchClearError() {
    window.dispatchEvent(new CustomEvent("clearError"))
  }

//  add() {
//    this.addLetter(event.currentTarget.innerHTML)
//  }

  addLetter(letter) {
    try {
      this.dispatchClearError()
      var currentLetter = document.querySelector('ol[data-controller="guesses"] li:last-of-type ul li:empty')
      currentLetter.innerHTML = letter
      var remaining = document.querySelectorAll('ol[data-controller="guesses"] li:last-of-type ul li:empty')
      if (remaining.length === 0) {
        var submitBtn = document.querySelector('[data-action="input#submit"]')
        if (submitBtn) submitBtn.focus()
      }
    } catch {
      // NOOP
    }
  }

  backspace() {
    this.dispatchClearError()
    try {
      var guesses = document.querySelectorAll('ol[data-controller="guesses"] li:last-of-type ul li:not(.locked):not(:empty)')
      var lastGuess = guesses[guesses.length - 1]
      lastGuess.innerHTML = ''
    } catch {
      // NOOP
    }
  }

  submit() {
    const trigger = new CustomEvent("submitGuess")
    window.dispatchEvent(trigger)
  }

  updateKeyColors(letterStates, useCounts) {
    this.element.querySelectorAll('button[data-action="input#add"]').forEach(btn => {
      const letter = btn.textContent.trim()
      const state = letterStates[letter]
      btn.dataset.keyState = state || ''
      if (state === 'locked' || state === 'hooked') {
        btn.style.removeProperty('background-color')
      } else {
        const uses = useCounts[letter] || 0
        const lightness = Math.max(15, 50 - uses * 10)
        btn.style.backgroundColor = `hsl(0, 0%, ${lightness}%)`
      }
    })
  }
}
